import { render, staticRenderFns } from "./chemProcessKnowhowDetail.vue?vue&type=template&id=31e3691a"
import script from "./chemProcessKnowhowDetail.vue?vue&type=script&lang=js"
export * from "./chemProcessKnowhowDetail.vue?vue&type=script&lang=js"
import style0 from "./chemProcessKnowhowDetail.vue?vue&type=style&index=0&id=31e3691a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e3691a')) {
      api.createRecord('31e3691a', component.options)
    } else {
      api.reload('31e3691a', component.options)
    }
    module.hot.accept("./chemProcessKnowhowDetail.vue?vue&type=template&id=31e3691a", function () {
      api.rerender('31e3691a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/chemProcessKnowhowDetail.vue"
export default component.exports